// Invoice and offer agent worklist.
window.PlummeI18n.register('no', {
  'ap.agent.sales.title': "Fakturaer og tilbud",
  'ap.agent.sales.pending': "{{count}} dokumenter er ikke sendt.",
  'ap.agent.sales.detail': "Send ferdige fakturaer og tilbud. Utkast må ferdigstilles i fakturalisten.",
  'ap.agent.sales.draft': "Utkast",
  'ap.agent.sales.invoices': "Fakturaer",
  'ap.agent.sales.drafts': "Utkast",
  'ap.agent.sales.offers': "Tilbud",
  'ap.agent.offer.sendSelected': "Send {{count}} valgte tilbud",
  'ap.agent.sales.sentCount': "{{count}} tilbud sendt",
  'ap.agent.sales.send': "Send",
  'ap.agent.sales.open': "Åpne",
  'ap.agent.sales.empty': "Ingen usendte dokumenter i denne listen.",
  'ap.agent.sales.unavailable': "Dokumentet kan ikke sendes. Åpne fakturalisten for å kontrollere status.",
  'ap.agent.sales.emailMissing': "Kunden mangler e-postadresse. Legg den til i fakturalisten før sending.",
  'ap.agent.sales.sendFailed': "Dokumentet ble ikke sendt. Prøv igjen fra fakturalisten.",
});
window.PlummeI18n.register('en', {
  'ap.agent.sales.title': "Invoices and offers",
  'ap.agent.sales.pending': "{{count}} documents have not been sent.",
  'ap.agent.sales.detail': "Send completed invoices and offers. Finish drafts in the invoice list.",
  'ap.agent.sales.draft': "Draft",
  'ap.agent.sales.invoices': "Invoices",
  'ap.agent.sales.drafts': "Drafts",
  'ap.agent.sales.offers': "Offers",
  'ap.agent.offer.sendSelected': "Send {{count}} selected offers",
  'ap.agent.sales.sentCount': "{{count}} offers sent",
  'ap.agent.sales.send': "Send",
  'ap.agent.sales.open': "Open",
  'ap.agent.sales.empty': "No unsent documents in this list.",
  'ap.agent.sales.unavailable': "The document cannot be sent. Open the invoice list to check its status.",
  'ap.agent.sales.emailMissing': "The customer has no email address. Add it in the invoice list before sending.",
  'ap.agent.sales.sendFailed': "The document was not sent. Try again from the invoice list.",
});
